// @flow

import type {
  ActionCreator,
} from 'fc-flow-types/redux'

// Utils
import createAction from 'fc-utils/createAction'

// Action Types
import {
  LOGIN,
  FETCH_TOKEN,
  RECEIVE_TOKEN,
  // TOKEN_FETCH_FAIL,
  REMOVE_CREDENTIALS,
  CREDENTIALS_REMOVED,
  IS_BOOTING,
  REQUEST_RESET_PASSWORD,
  RESET_PASSWORD,
} from './constants'

export const login: ActionCreator<{username: string, password: string}> = createAction(LOGIN)
export const removeCredentials: ActionCreator<> = createAction(REMOVE_CREDENTIALS)
export const credentialsRemoved: ActionCreator<> = createAction(CREDENTIALS_REMOVED)
export const fetchToken: ActionCreator<> = createAction(FETCH_TOKEN)
export const receiveToken: ActionCreator<{ user: string, token: string }> = createAction(RECEIVE_TOKEN)
export const isBooting: ActionCreator<{ isAuthenticated: boolean }> = createAction(IS_BOOTING)
export const requestResetPassword : ActionCreator<> = createAction(REQUEST_RESET_PASSWORD)
export const resetPassword : ActionCreator<> = createAction(RESET_PASSWORD)
